import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useAnalyticsStore } from "./AnalyticsStore/analyticsStore";
import { updateSearchParamValues } from "../../utils/updateSearchParamValues";

export const CameraDropDown = ({
  searchParams,
  setSearchParams,
}: {
  searchParams: URLSearchParams;
  setSearchParams: (searchParams: URLSearchParams) => void;
}) => {
  const {
    userFilters,
    setUserFilters,
    cameraOptions,
    cameraDropDownValue,
    setCameraDropDownValue,
    loadingCameras,
  } = useAnalyticsStore();

  const cameraIds = new Map();
  cameraOptions.forEach((object: any) => {
    cameraIds.set(object.camera_name, object.id);
  });

  return (
    <div key="camera_dropdown">
      <Autocomplete
        disablePortal
        multiple
        limitTags={1}
        value={
          cameraDropDownValue && cameraDropDownValue.length > 0
            ? cameraDropDownValue
                .map((cameraName: string) => {
                  const cameraOption = cameraOptions.find(
                    (camera: any) => camera.camera_name === cameraName
                  );
                  return cameraOption
                    ? { id: cameraOption.id, name: cameraOption.camera_name }
                    : null;
                })
                .filter((item: any) => item !== null)
            : []
        }
        options={
          cameraOptions && cameraOptions.length > 0
            ? cameraOptions.map((object: any) => ({
                id: object.id,
                name: object.camera_name,
              }))
            : []
        }
        getOptionLabel={(option) => {
          if (!option || typeof option === "string") {
            return option || "";
          }
          return option.name || "";
        }}
        isOptionEqualToValue={(option, value) => {
          if (!option || !value) return false;
          return option.id === value.id;
        }}
        loading={loadingCameras}
        onChange={(event, value: any[]) => {
          if (value !== null) {
            const cameraIdsArray: string[] = [];
            const cameraValuesArray: string[] = [];
            value.forEach((element: any) => {
              if (element && element.id && element.name) {
                cameraIdsArray.push(element.id);
                cameraValuesArray.push(element.name);
              }
            });
            if (localStorage.filtersSavedClicked === "true") {
              localStorage.setItem(
                "cameraDropDownValues",
                JSON.stringify(cameraValuesArray)
              );
              localStorage.setItem(
                "savedAnalyticsFilters",
                JSON.stringify({
                  parent_group: userFilters.parent_group,
                  site: userFilters.site,
                  camera: cameraIdsArray,
                  start_date: userFilters.start_date,
                  end_date: userFilters.end_date,
                })
              );
            }
            setCameraDropDownValue(cameraValuesArray);
            localStorage.setItem(
              "cameraDropDownValueAnalytics",
              JSON.stringify(cameraValuesArray)
            );

            setUserFilters((previousState) => {
              return { ...previousState, camera: cameraIdsArray };
            });
            updateSearchParamValues(
              {
                ...userFilters,
                camera: cameraIdsArray,
              },
              searchParams,
              setSearchParams,
              ""
            );
          }
        }}
        sx={{ width: 285 }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Cameras"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingCameras ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option?.id || Math.random()}>
            {option?.name || ""}
          </li>
        )}
      />
    </div>
  );
};
